define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-attr",
	"dojo/dom-style",
	"dojo/dom",
	"dojo/keys",
	"dojo/on",
	"dojo/promise/all",
	"dojo/query",
	"dojo/sniff",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/focus",
	"csi",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"dojo/text!./EmailFormListField.html",
	"csi/widget/CheckedMultiSelectDropdown",
	"dojo/NodeList-traverse"
], function(declare,lang,domAttr,domStyle,dom,keys,on,all,query,sniff,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,focus,csi,_,html,locale,template) {

	html.registerDataAttribute("DATA_EMAIL_USER", "email-user");

	// The list of all e-mails for hint.
	var allItems = [];
	// The width of selected recipients div
	var addrListWidth = 0;

	var _destroyNodes = function(/*Node[]*/nodesToDelete) {
		_.forEach(nodesToDelete, function(node) {
			html.destroyElement(node);
		});
	};

	return declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
		// base widget members
		templateString: template,

		// Boolean
		readOnly: false,

		// String
		iconClass: null,

		// DOMNode: Show icon "more_horiz" if we have to many recipients to show
		iconMore: null,
		
		// String: the attribute on the store item to be used as a tooltip
		tooltipAttr: null,

		// String: the attribute on the store item to be used as an indication if this item is expandable
		expandableAttr: null,

		// define these members to allow this widget participate in set/get('value') of Form
		value: null,
		multiple: true,

		// parameters for the drop-down list
		labelType: "html",
		labelAttr: "Label",

		// DOMNode: attach points
		addNode: null,

		// Widget: attach points
		selectNode: null,

		// extension point: called when the use clicks on the 'Expand' icon
		onExpandGroup: function(/*EmailFormListField*/thisWidget, /*String*/urlItem) {},

		startup: function() {
			this.inherited(arguments);

			if (this.name != 'attachments'){
				this.selectNode.own(
					on(this.selectNode, "change", lang.hitch(this, this._onChangeSelect))
				)
			}
			this.selectNode.own(
				on(this.selectNode, "keypress", function(evt) {
					var charOrCode = evt.charCode || evt.keyCode;
					if(charOrCode == 9) {
						var node = query.NodeList([evt.currentTarget]);
						var parentNode = node.parents("tr").next("tr");
						var nextNode = query(".dijitButton",parentNode[0])[0];

						if(!nextNode) {
							nextNode = query("input",parentNode[0])[0];
						}
						focus.focus(nextNode);
						if(sniff("ff")) {
							nextNode.lastElementChild ?  nextNode.lastElementChild.focus() : dom.byId(nextNode.id).focus();
						}
					}
				})
			);

			this.selectNode.validateType = "Email";
		},

		addItemsByUrls: function(urls) {
			// resolve urls to names and create items for them
			if (!urls || !urls.length)
				return;

			var store = this.get("store");
			var promises = _.map(urls, function(url) {
				return store.get(url);
			});

			all(promises).then( lang.hitch(this, function(objs) {
				_.forEach(objs, function(obj){
					this._addItem(obj);
				}, this);
				this._setTooltipForMore();
			}));
		},

		removeItemsByUrls: function(urls) {
			// summary: remove items by their URLs
			if (!urls || !urls.length)
				return;

			var nodesToDelete = [];
			this._iterateItemDOMNodes(function(node, url) {
				if (_.contains(urls, url))
					nodesToDelete.push(node);
			});

			_destroyNodes(nodesToDelete);
		},

		clearAllItems: function() {
			var nodesToDelete = [];
			allItems.length = 0;
			addrListWidth = 0;
			this._iterateItemDOMNodes(function(node){
				nodesToDelete.push(node);
			});

			_destroyNodes(nodesToDelete);
			this.iconMore = null;
		},

		_iterateItemDOMNodes: function(iterator, scope) {
			// summary: iterate over DOM nodes corresponding to chosen items.
			// It stops iterating and returns the DOM node if the iterator returns true value.
			var	ret;

			query(html.getDataAttributeSelector(html.DATA_EMAIL_USER), this.domNode).some(function(domNode) {
				var url = html.getDataAttribute(domNode, html.DATA_EMAIL_USER);
				if (url && iterator.call(scope, domNode, url)) {
					ret = domNode;
					return true;
				}

				return false;
			});

			return ret;
		},

		_getValueAttr: function() {
			var urls = [];

			this._iterateItemDOMNodes(function(node, url){
				urls.push(url);
			});

			return urls;
		},

		_setValueAttr: function(urls) {
			// resolve urls to names and create items for them
			this.clearAllItems();
			this.selectNode.resetSelected(urls); // handle the CheckedMultiSelectDropDown
			this.addItemsByUrls(urls);
		},

		_getStoreAttr: function(usersStore) {
			return this.selectNode.get("store");
		},

		_setStoreAttr: function(usersStore) {
			this.selectNode.set("store", usersStore);
		},

		_setTooltipForMore: function(){
			if (this.iconMore && allItems.length){
				this.iconMore.title = allItems.join(', ');
			}
		},

		_addItem: function(/*Object*/item) {
			if (!item)
				return;

			var store = this.get("store");
			var value = item[store.idProperty];
			var name = item[this.selectNode.labelAttr];
			var tooltip = (this.tooltipAttr ? item[this.tooltipAttr] : "") || "";
			var expandable = this.expandableAttr ? item[this.expandableAttr] : false;
			var allTooltip = item[store.nameProperty] + (tooltip ? '<' + tooltip + '>' : '');

			// Create a list of all recipients for the case when there are too many of them and we have to show "..." icon
			allItems.push(allTooltip);
			if (this.iconMore) {
				return;
			}

			var span = html.create("span", {"class":"dijitInline emailViewListItem"}, this.addNode);

			// Arbitrary email user has only email, we have to work on it's style and tooltip
			if (item[this.selectNode._newItemAttr]){
				if (tooltip == "") {
					tooltip = name;
				}
				name = '<span class="arbitraryEmailUser">' + _.escape(name) + '</span>';
			}

			html.setDataAttribute(span, html.DATA_EMAIL_USER, value);

			if (this.iconClass) {
				var iconText = "";
				if (this.materialIcon) {
					this.iconClass += ' material-icons';
					iconText = this.materialIcon;
				}
				html.create("span", {"class": this.iconClass, innerText: iconText}, span);
			}

			if (this.selectNode.labelType == "html") {
				html.create("span", {
					innerHTML: name,
					title: tooltip
				}, span);
			} else {
				html.text(span, name);
				domAttr.set(span, "title", tooltip);
			}

			if (!this.readOnly) {
				html.create("span", {
					"class": "csiActionIcon material-icons csi-email-user-delete",
					innerText: "close",
					onclick: lang.hitch(this, this._onClickRemoveItem),
					title: locale.resource("EmailRemoveUser")
				}, span);
			}

			var cmpStyle = domStyle.getComputedStyle(span);
			var margins = parseInt(cmpStyle['margin-right']) + parseInt(cmpStyle['margin-left']);
			addrListWidth += span.offsetWidth + margins;
			if ((this.name != 'attachments') && (addrListWidth >= this.addNode.offsetWidth - 25)){ // allow 25px for "..."
				addrListWidth -= span.offsetWidth;
				this.addNode.removeChild(span);

				this.iconMore = html.create("span", {
					"class": "csiActionIcon material-icons csi-email-more",
					innerText: "more_horiz"
				}, this.addNode);
				html.setDataAttribute(this.iconMore, html.DATA_EMAIL_USER, 'all-email-users');
			}
			return span;
		},

		_onChangeSelect: function(newValue) {
			this._refreshVisibleSelections();
		},
		
		_refreshVisibleSelections: function() {
			this.clearAllItems();

			_.each(this.selectNode.getSelectedItems(), function(val) {
				this._addItem(val);
			}, this);
			this._setTooltipForMore();
		},

		_onClickRemoveItem: function(/*Event*/e) {
			// summary: remove user
			var url = html.getDataAttribute(e.currentTarget.parentNode, html.DATA_EMAIL_USER);
			this.selectNode.removeSelection(url);
			html.destroyElement(e.currentTarget.parentNode);
			
			// regenerate e-mail trail (along with ellipses if necessary)
			this._refreshVisibleSelections();
			
			//fix for need to blur multiselect before remove item buttons becomes active
			focus.focus(this.domNode.parentNode);
		}
	});
});